module.exports = __webpack_public_path__ + "img/cases-brand-zedriv-lazyload-41.16193ed1.jpg";